module.exports = __webpack_public_path__ + "static/media/image21.89ef4bc6.png";